import styled from 'styled-components';
import get from 'lodash/get';
import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';

export enum TooltipPosition {
  TOP = 'top',
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export const LongTextWithTooltip = ({
  'data-aid': dataAid,
  className,
  value = '',
  position = TooltipPosition.TOP,
}: {
  'data-aid'?: string;
  className?: string;
  value: string;
  position?: string;
}) => {
  const textRef = useRef();
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const current: any = get(textRef, 'current');
    if (current) {
      if (current.clientWidth < current.scrollWidth) {
        setShowTooltip(true);
      }
    }
  }, [setShowTooltip, textRef]);

  const StyledTextMessage = () => (
    <StyledText data-aid={dataAid} ref={textRef}>
      {value}
    </StyledText>
  );

  return showTooltip ? (
    <Tooltip className={className} position={position} message={<TooltipMessage>{value}</TooltipMessage>}>
      <StyledTextMessage />
    </Tooltip>
  ) : (
    <StyledTextMessage />
  );
};

const TooltipMessage = styled.p`
  line-height: 162%;
  margin: 0;
  text-align: center;
  max-width: 300px;
`;

const StyledText = styled.span`
  display: block;
  line-height: 1.16; // to prevent y-axis text elements from being clipped
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
